import styled from 'styled-components';

const OptionChipSection = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px var(--radius-medium, 8px);
  align-self: stretch;

  flex-wrap: wrap;
`;

const OptionChip = styled.div`
  height: 28px;

  display: flex;
  align-items: center;

  padding: 8px;
  gap: 4px;

  border-radius: var(--radius-small, 4px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
`;

const OptionChipText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;

export { OptionChipSection, OptionChip, OptionChipText };
